<template>
  <div class="navbar">
    <div class="logo">
      <a href="/" class="logo"><img :src="logo"></a>
    </div>
    <div class="sub-menu">
      <Dropdown>
        <a href="javascript:void(0)">
            <span>{{username}}</span>
            <Icon type="arrow-down-b"></Icon>
        </a>
        <DropdownMenu slot="list">
            <router-link to="/setting/index"><DropdownItem>{{$t("Login.Information")}}</DropdownItem></router-link>
            <a @click="changePw()"><DropdownItem>{{$t("Login.changePw")}}</DropdownItem></a>
            <a @click="logout()"><DropdownItem divided>{{$t("Login.logout")}}</DropdownItem></a>
        </DropdownMenu>
      </Dropdown>
    </div>
  </div>
</template>
<script>
import logo from '@/assets/logo.svg'
import store from '@/store'
export default {
  name: 'NavBar',
  data () {
    return {
      logo: logo
    }
  },
  computed: {
    username () {
      return this.$store.getters.userName
    }
  },
  methods: {
    logout () {
      console.log('logout')
      localStorage.removeItem('bearer')
      store.dispatch('RemoveUser')
      this.$router.push({name: 'Login'})
    },
    changePw () {
      this.$router.push({name: 'ChangePw'})
    }
  }
}
</script>
<style lang="scss" scoped>
  .navbar {
    height: 50px;
    line-height: 50px;
    background-color: #fff;
    position: fixed;
    min-width: 100%;
    z-index: 1024;
    -ms-flex-align: stretch;
    align-items: stretch;
    box-shadow: 0 2px 3px hsla(0,0%,7%,.1), 0 0 0 1px hsla(0,0%,7%,.1);
  }
  .logo {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
    width: 200px;
  }
  .logo img {
    margin-right: 5px;
    max-width: 60px;
  }
  .logo span {
    vertical-align: top;
    font-weight: 700;
    color: #4a4a4a;
  }
  .sub-menu {
    float: right;
    margin-right: 45px;
  }
</style>





// WEBPACK FOOTER //
// NavBar.vue?f71fceec